import { Component, Input, ViewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';

import { ResponsiveHelperService } from '../../services/responsive-helper.service';

@Component({
  selector: 'app-info-circle',
  templateUrl: './info-circle.component.html',
  styleUrls: ['./info-circle.component.scss']
})
export class InfoCircleComponent {

  @Input() hidden = false;
  @Input() tooltip: string;
  @Input() useOverlay = false;
  @Input() overlayContent: string;
  @Input() renderAsButton = false;

  @ViewChild('overlayPanel') overlayPanel: OverlayPanel;

  constructor(
    public responsiveHelper: ResponsiveHelperService
  ) { }

  toggleOverlay(event: Event) {
    this.overlayPanel?.toggle(event);
  }

}
